import { render } from "./TableGutter.vue?vue&type=template&id=c20bb426"
import script from "./TableGutter.vue?vue&type=script&lang=js"
export * from "./TableGutter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__